import React from 'react';
import styled, { css } from 'styled-components';
import { Flex } from '@catalogo/theme-layout';
import Shipping from '@catalogo/ui-americanas-desktop-svg/shipping.svg';
import Store from '@catalogo/ui-americanas-desktop-svg/store.svg';

export const FreightIcon = ({ modalityTypeIcon }) => (
  <IconContainer>{modalityTypeIcon === 'RECEBER' ? <ShippingIcon /> : <StoreIcon />}</IconContainer>
);

const IconContainer = styled(Flex)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
`;

const Icon = css`
  fill: ${({ theme }) => theme.grey.dark};
  margin-right: 4px;
`;

const ShippingIcon = styled(Shipping)`
  ${Icon};
  height: auto;
  min-width: 19px;
  width: 19px;
`;

const StoreIcon = styled(Store)`
  ${Icon};
  height: 20px;
  min-width: 17px;
  width: 17px;
`;

FreightIcon.defaultProps = { modalityTypeIcon: 'RETIRAR' };

export default FreightIcon;
